import { Environment } from '@app/core/models';
import packageJson from '../package.json';

/**
 * For test environment.
 */
export const environment: Environment = {
  integrationPortalApi: {
    url: 'https://duravermeer-tst.azure-api.net/integrationportalexperience',
    scope: '36998896-fbc7-492e-96e9-58fae6714c1a/.default',
  },
  experienceApi: {
    url: 'https://duravermeer-tst.azure-api.net/integrationportalexperience',
  },
  production: false,
  version: packageJson.version,
  clientId: '9745357e-6bf1-4517-8ad0-bf12a62b93da',
  tenantId: '47ef05e2-eef7-412f-b794-3b99f6ab08e7',
};

